import { StatusCodes } from "http-status-codes";
import { request } from "../api";
import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { AUTHORIZATION } from "../../../constants/api/auth";

const { post, get } = request;
const { Authorization, Bearer } = AUTHORIZATION;

export type FindDependentWithEmployeeQuery = {
	SSN: string;
	group_number: number;
};

const initialRoute = "member";

export const getDependentBySSNWithEmployee = async (findDependentWithEmployeeQuery: FindDependentWithEmployeeQuery) => {
	try {
		const endpoint = `${initialRoute}/get-dependent-by-ssn-with-employee`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			findDependentWithEmployeeQuery
		);

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};
